<template functional>
  <div class="relative">
    <div class="test">
      <img
        class="logo"
        src="https://houseofdev.tech/assets/logo/house-of-dev-2.svg"
        alt=""
      />
    </div>
    <!-- <footer class="the-footer flex-wrap justify-between test" :class="classes">
    </footer> -->
  </div>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>

<style scoped>
.test {
  height: 3%;
  position: fixed;
  z-index: 100000;
  background-color: black;
  opacity: 0.5;
  width: 100vw;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
}

.logo {
  height: 100%;
}
</style>
